import { createContext } from "@-/com.npmjs.use-context-selectors";
import { defaultError } from "@-/com.npmjs.react-context-default-error";
import type { GraphemeMorphemePanelsContextValue } from "#grapheme-morpheme-panels-context-value";

export const GraphemeMorphemePanelsContext = createContext(
  defaultError<GraphemeMorphemePanelsContextValue>("GraphemeMorphemePanelsContext"),
);
